module.exports = __webpack_public_path__ + "img/KarimKaka-May.68aa7948.jpg";